import { GetPersonInvestmentProgrammesRes } from '@dealstack/shared/lib/generated';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';

export const getPersonInvestmentProgrammesRequest = async (
	personId: string
): Promise<GetPersonInvestmentProgrammesRes[]> => {
	return await makeRequest<ApiV1.Response<GetPersonInvestmentProgrammesRes[]>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_MIP_GET, {
			personId,
		}),
		method: HTTP_METHOD.GET,
	}).then((response) => response.payload ?? []);
};

export const linkPersonToInvestmentProgrammeRequest = async ({
	personId,
	mipId,
	linkTransactions,
}: {
	personId: string;
	mipId: string;
	linkTransactions: boolean;
}): Promise<GetPersonInvestmentProgrammesRes[]> => {
	return await makeRequest<ApiV1.Response<GetPersonInvestmentProgrammesRes[]>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_MIP_MIPID_LINK_POST, {
			personId,
			mipId,
		}),
		method: HTTP_METHOD.POST,
		queryString: {
			linkTransactions,
		},
	}).then((response) => response.payload ?? []);
};

export const unlinkInvestmentProgrammeRequest = async ({
	personId,
	mipId,
	unlinkTransactions,
}: {
	personId: string;
	mipId: string;
	unlinkTransactions: boolean;
}): Promise<GetPersonInvestmentProgrammesRes[]> => {
	return await makeRequest<ApiV1.Response<GetPersonInvestmentProgrammesRes[]>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_MIP_MIPID_UNLINK_POST, {
			personId,
			mipId,
		}),
		queryString: {
			unlinkTransactions,
		},
		method: HTTP_METHOD.POST,
	}).then((response) => response.payload ?? []);
};
